<h2 mat-dialog-title>Edit team settings</h2>
<mat-dialog-content>
  <p>Monthly company-funded benefit amount per employee.</p>
  @if (state.busy) {
    <p role="status">{{ state.baseline ? 'Saving…' : 'Loading…' }}</p>
  }
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Team name</mat-label>
    <input matInput [(ngModel)]="state.name" maxlength="80" required [disabled]="state.busy || !state.baseline">
  </mat-form-field>
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Monthly wellness amount ($)</mat-label>
    <input matInput type="number" [(ngModel)]="state.amount" min="0" max="999999.99" step="0.01"
      inputmode="decimal" required [disabled]="state.busy || !state.baseline">
    <mat-hint>$0–$999,999.99, with up to two decimal places</mat-hint>
  </mat-form-field>
  @if (state.error) {
    <p role="alert">{{ state.error }}</p>
  }
  @if (state.needsReload) {
    <p>Reload replaces the fields with the current saved settings.</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="state.busy">Cancel</button>
  @if (state.needsReload) {
    <button mat-button (click)="state.reload()" [disabled]="state.busy">Reload</button>
  }
  <button mat-raised-button color="primary" (click)="save()"
  [disabled]="state.busy || !state.baseline || !state.valid || state.needsReload">Save</button>
</mat-dialog-actions>
